/**
 * Add no scroll to the main body, so we don't get main window
 * scrolling while we're shown as modal and scrolling the modal.
 */
export function addNoScroll(): void {
  // Fixes the scrolling of the main page while modal is popped up
  const el = document.getElementsByTagName("body");
  if (el && el[0]) {
    el[0].classList.add("noscroll");
    // Remove the scrollbar
    el[0].style.overflow = "hidden";
  }
}

/**
 * Remove the noscroll class, so the main window can scroll.
 */
export function removeNoScroll(): void {
  // Remove the main page no scroll
  const el = document.getElementsByTagName("body");
  if (el && el[0]) {
    el[0].classList.remove("noscroll");
    el[0].style.overflow = "";
  }
}
